<template>
    <div class="principal">
        <NavBar :usarAberto="false" :usarHistorico="false" :usarVoltar="true" :usarDeslogar="false" :usarGerenciar="false"
            :usarRelatorio="false" :usarFiltroSetor="false" :usarFiltroTpChamado="false" :usarFiltroPosicao="false"
            :formatarDataInicioMes="formatarDataInicioMes" />
        <div class="p-2">
            <table id="tabela" class="table table-striped">
                <thead>
                    <th>
                        <p class="fs-3 mb-0" colspan="7"> {{ titulo }} </p>
                    </th>
                    <tr>
                        <button class="btn btn-info mb-2" style="background-color: #0dcaf0" colspan="7" @click="incluir()">
                            Incluir
                        </button>
                        <label class="form-check-label fs-6 align-self-center" for="somenteAtivos"
                            v-if="objeto?.ativo != null">
                            <!-- <input class="form-check-input" type="checkbox" id="somenteAtivos" @click="iniciarLista()"
                                v-model="state.somenteAtivos"> -->
                            <span class="text-decoration-underline" @click="alterarVisualizacao(1)"
                                v-show="state.exibicaoAtivos == 0">
                                Visualizar Todos
                            </span>
                            <span class="text-decoration-underline" @click="alterarVisualizacao(2)"
                                v-show="state.exibicaoAtivos == 1">
                                Somente Ativos
                            </span>
                            <span class="text-decoration-underline" @click="alterarVisualizacao(0)"
                                v-show="state.exibicaoAtivos == 2">
                                Somente Inativos
                            </span>
                        </label>
                    </tr>
                    <tr>
                        <td class="fw-bold fs-5" v-for="col in cabecalho" :key="col"> {{ col }} </td>
                        <td class="fw-bold fs-5" v-if="temLink"> Link </td>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                <tbody id="linhas">
                    <tr v-for="d in state.dados" :key="d.Id" :class="{ 'inativo': d.ativo == false }">
                        <td v-for="l in linhas" :key="l" class="py-0">
                            <span v-if="state.temAtivo && l == 'ativo'" class="text-center">
                                <!-- <img v-if="d.ativo" src="../assets/icons/check-square.svg" alt=""
                                    style="background-color: rgb(75, 233, 75);">
                                <img v-else src="../assets/icons/x-square.svg" alt=""> -->
                                <i v-if="d.ativo" class="bi bi-check-square" alt=""
                                    style="background-color: rgb(75, 233, 75);" />
                                <i v-else class="bi bi-file-x-fill" alt="" />
                            </span>
                            <span v-else-if="(typeof d[l] != 'object')">{{ d[l] }}</span>
                            <span v-else>{{ d[l].descricao }}</span>
                        </td>
                        <td class="py-0" v-if="temLink"> <a :href="`${link}/#/${d.id}`"> {{ link }}/#/{{ d.id }} </a> </td>
                        <td class="col-md-1 col-sm-1 py-0">
                            <button class="btn btn-info py-0" @click="alterar(d)">
                                Alterar
                            </button>
                        </td>
                        <td class="col-md-1 col-sm-1 py-0">
                            <button class="btn btn-danger py-0" @click="excluir(d.id)">
                                Excluir
                            </button>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                </tfoot>
            </table>
        </div>
    </div>
    <ModalEditar :mostrar="state.modal" @keyup.esc="cancelar()" :tamanhoModal="60">
        <template v-slot:header>
            <h3>{{ titulo }}</h3>
        </template>
        <template v-slot:corpo>
            <slot name="ficha"></slot>
        </template>
        <template v-slot:rodape>
            <button class="btn btn-success me-2" @click="enviar()">Confirmar</button>
            <button class="btn btn-secondary ms-2" @click="cancelar()">Cancelar</button>
        </template>
    </ModalEditar>
    <ModalConfirmaAgape :visible="state.temErro" :title="state.tituloErro" :text="state.erroText" :aviso="state.aviso"
        @modalResult="modalResult">

    </ModalConfirmaAgape>
</template>

<script setup>
import api from '@/api/api';
import ModalConfirmaAgape from './ModalConfirmaAgape.vue';
import ModalEditar from './ModalEditar.vue';
import NavBar from './NavBar.vue';
import { reactive, onMounted, computed, defineProps } from 'vue';

const props = defineProps(['cabecalho', 'linhas', 'titulo', 'url', 'limparInput', 'objeto', 'calculoCodigo', 'temLink', 'link', 'formatarDataInicioMes',
    'calcularCodigo', 'lstObrigatorios', 'lstObrigatoriosLabel']);

onMounted(() => {
    // console.log(Object.keys(props.objeto));
    iniciarLista();
    console.log(props.lstObrigatorios);
    temAtivo();
});

const state = reactive({
    dados: [],
    modal: false,
    alterando: Boolean(),
    erroText: String(),
    temErro: Boolean(),
    auxId: Number(),
    temAtivo: Boolean(),
    icone: "",
    exibicaoAtivos: Number(1),
    aviso: Boolean(),
    tituloErro: String(),
});

async function iniciarLista() {
    let ativos = `?exibirAtivos=`;

    switch (state.exibicaoAtivos) {
        case 1:
            ativos += "true";
            break;
        case 2:
            ativos += "false";
            break;
    }

    // console.log(`/api/${props.url}/Listar${ativos}`);

    await api.listaDinamica(`/api/${props.url}/Listar${ativos}`)
        .then(resp => {
            // console.log(resp);
            if (resp) {
                state.dados = resp;
            }
        });
}

function alterarVisualizacao(pVisualizacao) {
    state.exibicaoAtivos = pVisualizacao;
    iniciarLista();
}

async function incluir() {
    props.limparInput();
    state.modal = true;
    state.alterando = false;
}

async function alterar(pObj) {
    props.limparInput(pObj);
    state.modal = true;
    state.alterando = true;
}

async function excluir(pId) {
    state.auxId = pId;
    state.temErro = true;
}

async function enviar() {
    let obrigatoriosPreenchidos = 0;
    if (props.calculoCodigo) {
        props.calcularCodigo();
    }

    // console.log(props.lstObrigatorios);

    if (props.lstObrigatorios) {
        props.lstObrigatorios.forEach(o => {
            if (props.objeto[o])
                obrigatoriosPreenchidos++;
        });
    }
    // console.log(props.objeto);

    if (obrigatoriosPreenchidos == props.lstObrigatorios.length) {
        if (state.alterando) {
            await api.alterarDinamico(`/api/${props.url}`, props.objeto);
        } else {
            await api.inserirDinamico(`/api/${props.url}`, props.objeto);
        }
        state.modal = false;
        state.alterando = false;
        iniciarLista();
    } else {
        state.erroText = "Os seguintes campos devem ser preenchidos: \n";
        props.lstObrigatorios.forEach((o, i) => {
            if (!props.objeto[o]) {
                state.erroText += `${props.lstObrigatoriosLabel[i]}`;
                if (i < props.lstObrigatorios.length - 1)
                    state.erroText += ", ";
            }
        });
        state.temErro = true;
        state.aviso = true;
        state.tituloErro = "Aviso";
    }
}

function cancelar() {
    state.modal = false;
    iniciarLista();
}

async function modalResult(result) {
    if (result === "ok") {
        await api.excluirDinamico(`/api/${props.url}`, state.auxId);
        iniciarLista();
    }
    state.temErro = false;
    state.aviso = false;
    state.tituloErro = "";
}

function temAtivo() {
    if (Object.keys(props.objeto).includes("ativo")) {
        state.temAtivo = true;
    }
}

</script>

<style scoped>
.inativo {
    background-color: rgb(255, 115, 115);
}
</style>